/*@ngInject*/
const UserMenuController = function ($rootScope, $scope, $element, $state, $stateParams, coreConstant, loadingBarHandler, localization, userMediator, formViewerConstant, userUtil) {

    $element.addClass('userMenu');

    this.navigationItemList = [];
    this.selectedItem = null;

    this.$onInit = function () {
        localization.getTranslations().then((translations) => {

            this.processList = function (formSummaries) {
                formSummaries = _.filter(formSummaries, userUtil.isValidNavigationItem);

                const groupedList = _.groupBy(formSummaries, function (formSummary) {
                    return _.get(translations, 'user.manage.formTemplateType.' + formSummary.formTemplateType);
                });

                this.navigationItemList = [];
                if (formSummaries.length === 1) {
                    this.onMenuHasSingleItem();
                } else {
                    this.onMenuHasMultipleItems();
                }

                _.each(groupedList, (item) => {
                    let itemToPush, selectedChild = null;

                    if (item.length === 1) {
                        itemToPush = item[0];
                    } else {
                        itemToPush = {
                            name: _.get(translations, 'user.manage.formTemplateType.' + item[0].formTemplateType),
                            children: item,
                            isOpen: false
                        };
                    }

                    if (!_.isNil(itemToPush)) {
                        if (!_.isNil(itemToPush.totalRequiredFieldCount)) {
                            itemToPush.requiredFieldCount = itemToPush.totalRequiredFieldCount;
                        }

                        let requiredFieldCount = 0;
                        if ($stateParams.formId) {
                            if (itemToPush.id && $stateParams.formId === itemToPush.id.toString()) {
                                this.selectedItem = itemToPush;
                            } else if (itemToPush.children) {
                                _.each(itemToPush.children, function (item) {
                                    if (!_.isNil(item.totalRequiredFieldCount)) {
                                        item.requiredFieldCount = item.totalRequiredFieldCount;
                                    }

                                    requiredFieldCount += item.requiredFieldCount;
                                    if (item.id && $stateParams.formId === item.id.toString()) {
                                        selectedChild = item;
                                    }
                                });
                                if (selectedChild) {
                                    this.selectedItem = selectedChild;
                                }
                                itemToPush.requiredFieldCount = requiredFieldCount;
                            }
                        } else if (itemToPush.children) {
                            _.each(itemToPush.children, function (item) {
                                if (!_.isNil(item.totalRequiredFieldCount)) {
                                    item.requiredFieldCount = item.totalRequiredFieldCount;
                                }

                                requiredFieldCount += item.requiredFieldCount;
                            });
                            itemToPush.requiredFieldCount = requiredFieldCount;
                        }

                        this.navigationItemList.push(itemToPush);
                    }
                });
            };
        });

        $scope.$on(coreConstant.event.UPDATE_USER, (event, result) => {
            if (result.id === this.userId) {
                this.getUserForms();
            }
        });

        $scope.$on(formViewerConstant.event.FORM_DATA_READY, (event, fieldModel) => {
            this.getUserForms();
        });

        $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, (event, fieldModel) => {
            this.getUserForms();
        });

        this.loadUserForms();
    };

    this.onRequiredIndicatorClicked = function (event, navItem) {
        let isChangingState = false;
        if (navItem.children) {
            isChangingState = navItem.id !== this.selectedItem.id;
            _.each(navItem.children, function (item) {
                if (item.requiredFieldCount > 0) {
                    navItem = item;
                    return false;
                }
            });
        } else {
            isChangingState = navItem.id !== this.selectedItem.id;
        }

        this.onNavChildItemClick(navItem);
        if (isChangingState) {
            $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
        } else {
            $rootScope.$broadcast('showNextRequiredField');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.id.toString());
        }
    };

    this.validatedSelectedItem = function () {
        let selectedItemExists;

        function isItemInList(itemList, targetValue) {
            let result = false;

            _.each(itemList, (item) => {
                if (item.id === targetValue) {
                    result = true;
                } else if (item.children) {
                    result = isItemInList.call(this, item.children, targetValue);
                }
            });

            return result;
        }

        if (!this.selectedItem) {
            if (this.defaultSelectedValue) {
                this.selectedItem = _.find(this.navigationItemList, {id: this.defaultSelectedValue});
            } else {
                this.selectedItem = this.navigationItemList[0];
            }
        } else {
            selectedItemExists = isItemInList.call(this, this.navigationItemList, this.selectedItem.id);

            if (!selectedItemExists) {
                this.selectedItem = this.navigationItemList[0];
            }
        }
    };

    this.onNavItemClick = function (itemValue) {
        let item = _.find(this.navigationItemList, function (navigationItem) {
            return navigationItem.id === itemValue;
        });

        if (!item.children) {
            this.notifyChange(item);
        }
    };

    this.onNavChildItemClick = function (item) {
        this.notifyChange(item);
    };

    this.notifyChange = function (item) {
        this.selectedItem = item;
        this.onSelectedItemChange({datasetItem: this.selectedItem});
    };

    this.hasChildren = function (item) {
        return !_.isEmpty(item.children);
    };

    this.isActive = function (childItem) {
        return this.defaultSelectedValue === parseInt(childItem.id);
    };

    this.isItemOpen = function (item) {
        let result = false;

        if (item.id === this.defaultSelectedValue && this.hasChildren(item)) {
            result = true;
        } else {
            _.each(item.children, (item) => {
                if (item.id === this.defaultSelectedValue) {
                    result = true;
                }
            });
        }
        return result;
    };

    this.getUserForms = function () {
        return userMediator.getForms(this.userId).then((result) => {
            this.processList(result);
            this.validatedSelectedItem();
            if (this.selectedItem) {
                this.notifyChange(this.selectedItem);
            }
        });
    };

    this.loadUserForms = function () {
        loadingBarHandler.showLoadingBar();
        this.getUserForms().then(function () {
            loadingBarHandler.hideLoadingBar();
        });
    };
};

angular.module('umCore')
    .controller('userMenuController', UserMenuController);
